<template>
  <recipe :recipe-name="recipeName" :pre-pack="prePack" :post-pack="postPack" />
</template>
<script>
import { recipeCustom } from '~/components/recipes/mixins/custom'
export default {
  name: 'DoccurateItemToPalletCarton',
  mixins: [recipeCustom]
}

</script>
